import React from "react"
import { HOW_IT_WORKS } from "../constants"

export const HowItWorks: React.FC = () => (
  <section id="how-it-works" className="bg-[#161616] py-24">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
      <div className="text-center mb-16">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest">
          Simple Process
        </span>
        <h2 className="text-4xl font-black text-white mt-2">How it works</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {HOW_IT_WORKS.map(({ n, title, body }) => (
          <div key={n} className="relative">
            <div className="text-6xl font-black text-white/5 mb-4 leading-none">{n}</div>
            <h3 className="text-lg font-bold text-white mb-2 -mt-6">{title}</h3>
            <p className="text-neutral-500 text-sm leading-relaxed">{body}</p>
            <div className="absolute top-3 left-0 w-6 h-0.5 bg-emerald-500" />
          </div>
        ))}
      </div>
    </div>
  </section>
)